'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import UITourStep from 'ui-shepherd-react/tour/UITourStep';
import { existingUserSteps } from 'DesignData/constants/Onboarding';
import NewFolderForm from 'DesignFinderUI/components/forms/NewFolderForm';
import * as folderActions from 'DesignData/actions/finder/Folders';

function mapStateToProps() {
  return {};
}

const mapDispatchToProps = {
  createFolder: folderActions.createFolder
};

class NewFolderStep extends PureComponent {
  constructor(props) {
    super(props);
    this.callback = this.callback.bind(this);
  }

  callback(data) {
    const {
      createFolder
    } = this.props;

    if (!data) {
      this.context.tour.finish();
    }

    if (data && data.folderName) {
      createFolder(data.folderName);
      this.context.tour.next();
    }
  }

  renderContent() {
    return /*#__PURE__*/_jsx(NewFolderForm, {
      callback: this.callback
    });
  }

  render() {
    return /*#__PURE__*/_jsx(UITourStep, {
      stepKey: existingUserSteps.NEW_FOLDER_STEP,
      className: "new-folder-step",
      content: {
        body: this.renderContent()
      },
      placement: "bottom right",
      width: 300,
      children: this.props.children
    });
  }

}

NewFolderStep.propTypes = {
  children: PropTypes.node.isRequired,
  createFolder: PropTypes.func.isRequired
};
NewFolderStep.contextType = TourContext;
export default connect(mapStateToProps, mapDispatchToProps)(NewFolderStep);